import { NUMBER } from "../../../constants/app-constants";
import priceFormatter from "../../../utils/helpers/price-formatter";
import sortByKey from "../../../utils/helpers/sort-by-key";
import {
    HOLD_TYPES,
    REQUIRED_DOCUMENTS,
    CHALLAN_TYPES,
    CHARGE_TYPES,
    PAI_STATES,
    DOCTET_API_APPLICABLE_STATES,
    APPLICABLE_THIRD_PARTY_SCENARIONS,
    DIY_DOCUMENT_VERFIFICATION_STATES,
    AADHAR_LABELS,
    AADHAR_PAGE,
    FILTERED_TRANSACTION_LIST,
    SCREEN_TYPES
} from "./constant";
import { PICKUP_STATUS, PURCHASE_REQUEST_STATUS, PRICE_DISCOVERY } from "../../../constants/seller-diy-constants";
import { PRICE_DISCOVERY_NOT_OVER, TAB_NAMES } from "../post-inspection-diy-header-v2/constant";
import PostInspectionDiyCarHandover from "../post-inspection-diy-car-handover";
import PostInspectionDiyCarInspection from "../post-inspection-diy-car-inspection";
import PostInspectionDiyDocumentationTab from "../post-inspection-diy-documentation-tab";
import PostInspectionDiyPriceTab from "../post-inspection-diy-price-tab";
import { REPORT_STATUS } from "../post-inspection-diy-car-inspection/constant";

export const TAB_LIST = [
    {
        title: "Car Inspection",
        name: TAB_NAMES.CAR_INSPECTION,
        component: PostInspectionDiyCarInspection,
        completedStep: false
    },
    {
        title: "Price Discovery",
        name: TAB_NAMES.PRICE,
        component: PostInspectionDiyPriceTab,
        completedStep: false
    },
    {
        title: "Deal Closure",
        name: TAB_NAMES.DOCUMENTATION,
        component: PostInspectionDiyDocumentationTab,
        completedStep: false
    },
    {
        title: "Car Handover",
        name: TAB_NAMES.PICKUP_PAYMENT,
        component: PostInspectionDiyCarHandover,
        completedStep: false
    }
];

export const getUpdatedPriceDiscovery = ({priceDiscovery, isExpired, customerOcb, auctionType = ""}) => {
    // return PRICE_DISCOVERY.NOT_STARTED;
    if (isExpired && priceDiscovery === PRICE_DISCOVERY.OVER) return PRICE_DISCOVERY.OVER;
    if (priceDiscovery === PRICE_DISCOVERY.START && (customerOcb || auctionType === "OCB")) return PRICE_DISCOVERY.NEGOTIATE_PRICE_REQUESTED;
    return priceDiscovery;
};

export const getFilteredTransaction = (list, type) => {
    return list && list[type] && list[type].filter(elem => FILTERED_TRANSACTION_LIST.includes(elem.status));
};

export const getTransactionDetailsAsList = (data) => {
    let list = [];

    Object.keys(data).forEach((item) => {
        const details = getFilteredTransaction(data, item);
        if (details && details.length) list = [...list, ...details];
    });

    return list;
};

export const parseTransactionDetails = (data = {}, paymentType) => {
    if (!paymentType) return getTransactionDetailsAsList(data);
    const details = getFilteredTransaction(data, paymentType);
    return details && details[0];
};

export const getFileType = (file, seperator = ".") => {
    const fileName = file && file.split("?")[0];
    const fileExtension = fileName.split(seperator).pop();
    return fileExtension ? fileExtension.toLowerCase() : "";
};

export const parseChallanDetails = (data = {}) => {
    const { detail: challanList = [] } = data || {};
    const clearedChallanList = [];
    const pendingChallanList = [];
    let totalChallanAmount = NUMBER.ZERO;

    challanList.forEach((item) => {
        totalChallanAmount += item.amount;
        const challanDoc = item.status === CHALLAN_TYPES.PAID ? item.challanReceipt : item.challanProof;
        const fileType = getFileType(challanDoc);
        const challan = {
            ...item,
            challanDoc,
            fileType: fileType.toUpperCase(),
            isPdf: fileType === "pdf"
        };

        if (item.status === CHALLAN_TYPES.PAID) {
            clearedChallanList.push({
                ...challan,
                isCleared: true
            });
        } else {
            pendingChallanList.push(challan);
        }
    });

    return {
        totalChallanAmount,
        totalChallanCount: challanList.length,
        areAllChallansCleared: clearedChallanList.length === challanList.length,
        challanDetails: {
            clearedChallanList,
            pendingChallanList
        }
    };
};

export const getFilteredData = (list) => {
    const data = [];
    let totalCount = NUMBER.ZERO;
    let serviceChargeAmount = 0;

    list.forEach((item) => {
        if (item.amount > NUMBER.ZERO && item.isApplicable) {
            if (item.label !== HOLD_TYPES.SERVICE) totalCount += item.amount;
            if (item.label === CHARGE_TYPES.SERVICE) serviceChargeAmount = item.amount;
            data.push({
                ...item
            });

        }
    });

    return {
        data,
        totalCount,
        serviceChargeAmount
    };
};

const getChargesWithoutServiceCharge = (allCharges, showServiceCharge, serviceChargeAmount) => {
    if (!showServiceCharge && serviceChargeAmount) {
        return allCharges.filter(item => item.label !== CHARGE_TYPES.SERVICE);
    }
    return allCharges;
};

const getVideoLinks = (list) => {
    return list
        .map(item => item.additionalData && item.additionalData.videoLink)
        .filter(videoLink => videoLink);
};

export const parseChargesAndHoldbacks = (chargesAndHoldback = {}, showServiceCharge = false) => {
    const { charges: chargesList = [], holds: holdsList = [] } = chargesAndHoldback;
    const { data: allCharges, totalCount: totalCharges, serviceChargeAmount } = getFilteredData(chargesList);
    const { data: holds, totalCount: totalHolds } = getFilteredData(holdsList);
    const videos = getVideoLinks(holds);

    return {
        charges: getChargesWithoutServiceCharge(allCharges, showServiceCharge, serviceChargeAmount),
        holds: sortByKey(holds, "displayOrder", "asc"),
        totalCharges,
        totalHolds,
        serviceChargeAmount,
        videos
    };
};

export const getRequiredDocumentsList = (list) => {
    const docs = {};

    Object.keys(list).forEach((item) => {
        if (REQUIRED_DOCUMENTS.includes(item)) docs[item] = list[item];
    });

    return docs;
};

export const isDoctetAllowed = (currentState) => {
    return DOCTET_API_APPLICABLE_STATES.includes(currentState);
};

export const getPaiState = ({offeredPrice, customerExpectedPrice}) => {
    if (offeredPrice === NUMBER.ZERO) {
        if (customerExpectedPrice !== null && customerExpectedPrice !== NUMBER.ZERO) {
            return PAI_STATES.PAI_PRICE_NOT_AVAILABLE;
        }
        return PAI_STATES.PAI_PRICE_NO_BIDS;
    } else if (customerExpectedPrice > NUMBER.ZERO) {
        if (offeredPrice === customerExpectedPrice) {
            return PAI_STATES.PAI_PRICE_RECEIVED;
        } else {
            return PAI_STATES.PAI_DNP_PRICE;
        }
    }
    return "";
};

export const isAuctionOver = priceDiscovery => priceDiscovery !== PRICE_DISCOVERY.START;

export const isAuctionRunning = priceDiscovery => priceDiscovery === PRICE_DISCOVERY.START;

export const getOfferedPrice = (priceBreakup) => {
    const { priceAfterDeductions } = priceBreakup || {};
    return `₹${priceFormatter(priceAfterDeductions)}`;
};

export const isNonThirdParty = (status) => {
    return APPLICABLE_THIRD_PARTY_SCENARIONS.includes(status);
};

export const checkNonThirdParty = (adhar = {}, pan = {}) => (isNonThirdParty(adhar.status) || isNonThirdParty(pan.status));

export const isDocumentVerified = (doc = {}) => {
    const { verified, status } = doc;
    return verified || status === DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED_CONFIRMED;
};

export const isEkycDocVerified = (documents = {}) => {
    const { otherDocuments } = documents;
    const kycDocs = otherDocuments.KYC_DOCUMENTS || [];
    return kycDocs.some((doc) =>
        doc.status !== DIY_DOCUMENT_VERFIFICATION_STATES.UPLOAD_PENDING
    );
};

export const getAadharPageFlag = (page = "") =>  page.match(/[A-Z]/i)[0];

export const getAadharLabel = (doc = "") => {
    const label = getAadharPageFlag(doc.page);
    return  AADHAR_LABELS[label];
};

export const getAadharPage = (page = "") => {
    const label = getAadharPageFlag(page);
    return AADHAR_PAGE[label];
};

export const getDocDetails = (isAadhaar = false) => {
    if (isAadhaar) {
        return {
            docType: "Aadhaar card",
            gaEventType: "Aadhaar verification",
            gaEventCategory: "DIY_aadhar_verify"
        };
    }
    return {
        docType: "PAN card",
        gaEventType: "Pan verification",
        gaEventCategory: "DIY_pan_verify"
    };
};

export const getTabList = ({ purchaseRequestStatus, isDeliveryApproved, pickupStatus, carHealthStatus }) => {
    return TAB_LIST.map(tabDetails => {
        switch (tabDetails.name) {
        case TAB_NAMES.CAR_INSPECTION:
            return carHealthStatus === REPORT_STATUS.BOUGHT ? {...tabDetails, completedStep: true} : tabDetails;
        case TAB_NAMES.PRICE:
            return purchaseRequestStatus === PURCHASE_REQUEST_STATUS.CREATED ? { ...tabDetails, completedStep: true } : tabDetails;
        case TAB_NAMES.DOCUMENTATION:
            return isDeliveryApproved ? { ...tabDetails, completedStep: true } : tabDetails;
        case TAB_NAMES.PICKUP_PAYMENT:
            return pickupStatus === PICKUP_STATUS.PICKUP_COMPLETED ? { ...tabDetails, completedStep: true } : tabDetails;
        default:
            return tabDetails;
        }
    });
};
export const getHeaderText = (carDetails) => {
    const {
        year = "",
        make_display: makeName = "",
        model_display: modelName = ""
    } = carDetails || {};

    if (carDetails) return `${year ? year : ""} ${makeName ? makeName : ""} ${modelName ? modelName : ""} `;
    return "";
};

// eslint-disable-next-line complexity
export const showPriceCta = ({ activeTab, screen, priceDiscovery, offeredPrice, dnpPriceConfirmationEnabled, isPrExists, isExpired }) => {
    if (activeTab === TAB_NAMES.PRICE &&
        (!PRICE_DISCOVERY_NOT_OVER.includes(priceDiscovery) ||
            (priceDiscovery === PRICE_DISCOVERY.ACCEPTED && !isPrExists))
        && !!offeredPrice && !isExpired &&
        (screen === SCREEN_TYPES.DEFAULT ||
            (screen === SCREEN_TYPES.SELF_NEGOTIATION &&
            dnpPriceConfirmationEnabled))) return true;
    return false;
};
